import React from "react";
import "./openSource.css";

export default function OpenSource() {
  return (
    <small className="open-source">
      <a
        href="https://github.com/AliWilkinson/dictionary-app-react"
        target="_blank"
        rel="noreferrer"
      >
        Open-source code{" "}
      </a>
      by Ali Wilkinson
    </small>
  );
}
